import React from 'react';
import './NoResults.css';

const NoResults = () => (
    <section className="no-results">
        <div className="container has-text-centered">
            <h1 className="big-title">NO PROPERTIES FOUND</h1>
            <h2 className="sub-title">No properties match your search.</h2>
        </div>
    </section>
);


export default NoResults;
